// /src/utils/api.ts (o donde prefieras)

import { toJson } from "../../MayzSmartDB/Commons";

export async function saveXShare(userAddress: string, txHash: string) {
    try {
        const response = await fetch('/api/incentivized/x-share', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: toJson({
                userAddress,
                txHash,
            }),
        });

        const data = await response.json();

        if (!response.ok) {
            return {
                success: false,
                error: data.error,
                message: data.message,
            };
        }

        return { success: true, data: data.data };
    } catch (error) {
        console.error('Error saving X share:', error);
        return {
            success: false,
            error: 'Network error',
            message: 'Failed to connect to server',
        };
    }
}
